var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DashboardCustomizeRounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 3H10C10.55 3 11 3.45 11 4V10C11 10.55 10.55 11 10 11H4C3.45 11 3 10.55 3 10V4C3 3.45 3.45 3 4 3ZM14 3H20C20.55 3 21 3.45 21 4V10C21 10.55 20.55 11 20 11H14C13.45 11 13 10.55 13 10V4C13 3.45 13.45 3 14 3ZM4 13H10C10.55 13 11 13.45 11 14V20C11 20.55 10.55 21 10 21H4C3.45 21 3 20.55 3 20V14C3 13.45 3.45 13 4 13ZM17 13C16.45 13 16 13.45 16 14V16H14C13.45 16 13 16.45 13 17C13 17.55 13.45 18 14 18H16V20C16 20.55 16.45 21 17 21C17.55 21 18 20.55 18 20V18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H18V14C18 13.45 17.55 13 17 13Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypesIcon);
export default __webpack_public_path__ + "static/media/types-icon.2b5963d792de023f3bed2403829ce9d3.svg";
export { ForwardRef as ReactComponent };